import { Form, Formik } from "formik";
import { FormikInput } from "@/components/common/form/FormikInput.tsx";
import { Button } from "@/components/base/Button.tsx";
import * as yup from "yup";
import { useStore } from "@/stores/useStore.ts";
import { useState } from "react";
import { Link } from "react-router-dom";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
});

export const ResetPasswordForm = () => {
  const resetPassword = useStore((s) => s.resetPassword);
  const [resetSent, setResetSent] = useState(false);
  return (
    <Formik
      initialValues={{
        email: "",
      }}
      onSubmit={(values) => {
        resetPassword(values.email);
        setResetSent(true);
      }}
      validationSchema={validationSchema}
    >
      {({ isValid }) => (
        <Form className="flex flex-col gap-4 m-auto sm:w-64">
          <FormikInput name="email" id="email" label="E-mail" type="email" />
          <Button disabled={!isValid || resetSent} type="submit">
            Submit
          </Button>

          {resetSent && (
            <div className="flex flex-col">
              <p>Check your inbox for an email to reset your password</p>
              <p>
                Return to{" "}
                <Link to={"/login"} className="underline">
                  Login
                </Link>
              </p>
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};
